/**
 * multiInstanceTiers.js
 *
 * Frontend mirror of the tier→cap mapping in
 * functions/subWorldManagement.js (INSTANCE_TIERS + resolveInstanceCap).
 * Keep in sync — backend remains the enforcement boundary.
 */

export const INSTANCE_TIERS = {
  tier1: 10,
  tier2: 100,
};

export const INSTANCE_TIER_OPTIONS = [
  { value: null, label: 'Disabled', cap: 0 },
  { value: 'tier1', label: 'Tier 1 (10)', cap: INSTANCE_TIERS.tier1 },
  { value: 'tier2', label: 'Tier 2 (100)', cap: INSTANCE_TIERS.tier2 },
];

export const DEFAULT_TIER_CAP = INSTANCE_TIERS.tier1;
export const HARD_CAP = 100;

/**
 * Resolves the effective sub-instance cap for a user from their stored fields.
 * Mirrors backend resolveInstanceCap() — see subWorldManagement.js.
 */
export function resolveInstanceCap(userData) {
  if (typeof userData?.multiInstanceCap === 'number' && userData.multiInstanceCap > 0) {
    return Math.min(userData.multiInstanceCap, HARD_CAP);
  }
  const tier = userData?.multiInstanceTier;
  if (tier && INSTANCE_TIERS[tier]) {
    return Math.min(INSTANCE_TIERS[tier], HARD_CAP);
  }
  return Math.min(DEFAULT_TIER_CAP, HARD_CAP);
}
